module.exports = __webpack_public_path__ + "img/nt4vyS9E.d5a1eefb.png";